import { render, staticRenderFns } from "./MyDataTable.vue?vue&type=template&id=36fe8a46"
import script from "./MyDataTable.vue?vue&type=script&lang=js"
export * from "./MyDataTable.vue?vue&type=script&lang=js"
import style0 from "./MyDataTable.vue?vue&type=style&index=0&id=36fe8a46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports